<template>
  <div id="app" :class="[$tvaMq]">
    <RotateAllert v-if="$touchDevice || $tvaMq !== 'desktop'" />
    <IEMessage v-if="$isIE" />
    <router-view v-else />
  </div>
</template>
<script>
// import "@/compiled-icons";
import IEMessage from "@/components/IEMessage";
import RotateAllert from "@/components/RotateAllert";

export default {
  name: "App",
  beforeCreate() {
    if (this.$route.params.lang) {
      this.$ml.change(this.$route.params.lang);
    }
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  },
  watch: {
    $route(to) {
      if (to.name !== "wip") {
        localStorage.setItem("usersnap-start", true);
      }
      if (this.$route.params.lang) {
        this.$ml.change(to.params.lang);
      }
      // Google analytics send custom event every page change
      gtag("event", "changePage", {
        event_category: "page",
        event_label: to.path,
        value: to.fullPath
      });
    }
  },
  metaInfo() {
    // const content = {};
    // content.ita = {
    //   title: "DivineComedy.digital",
    //   description:
    //     "Un progetto di digital humanities sulla Divina Commedia di Dante Alighieri che celebra la sua influenza sul patrimonio culturale e artistico mondiale",
    //   tags: ["Divina Commedia, Dante Alighieri, digital humanities"],
    //   url: "https://thevisualagency.com/",
    //   quote: "This will be the quote of the post",
    //   hashtag: "Divinecomedy"
    // };
    // content.eng = {
    //   title: "DivineComedy.digital",
    //   description:
    //     "A digital humanities project celebrating Dante Alighieri’s Divine Comedy and its influence on the world’s artistic and cultural heritage",
    //   tags: ["Divine Comedy, Dante Alighieri, digital humanities"],
    //   url: "https://thevisualagency.com/",
    //   quote: "This will be the quote of the post",
    //   hashtag: "Divinecomedy"
    // };
    // let meta = content[this.$ml.current];

    let meta = this.$ml.get("metadata");
    return {
      title: meta.title,
      meta: [
        {
          property: "description",
          content: meta.description
        },
        {
          property: "og:title",
          content: meta.title
        },
        {
          property: "og:description",
          content: meta.description
        },
        {
          property: "og:image",
          content: `${this.baseUrl}images/jpg/social.jpg`
        },
        {
          property: "og:image:width",
          content: 1200
        },
        {
          property: "og:image:height",
          content: 627
        },
        {
          property: "og:type",
          content: "website"
        },
        {
          property: "og:site_name",
          content: meta.url
        },
        {
          property: "twitter:title",
          content: meta.title
        },
        {
          property: "twitter:description",
          content: meta.description
        },
        {
          property: "twitter:image",
          content: `${this.baseUrl}images/jpg/social.jpg`
        },
        {
          property: "twitter:image:alt",
          content: meta.title
        },
        {
          property: "twitter:site",
          content: meta.url
        }
      ]
    };
  },
  components: {
    IEMessage,
    RotateAllert
  }
};
</script>
<style lang="scss">
a {
  text-decoration: none;
}
// GLOBAL
body {
  margin: 0;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
  background: "blue";
  font-size: 2.5vh;
}
#app {
  overflow: hidden;
  *,
  ::before,
  ::after {
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    -webkit-tap-highlight-color: transparent;
  }
}
</style>
